<div class="inspiration-wrapper">
  <div class="inspiration-header">
    <span class="casto-title large" [innerHTML]="'need_mapping.title'|translate"></span>
  </div>
  <div class="inspiration-container">
    <div class="tablist-container">
      <ul class="tablist">
        <li [class.clickable]="true"
            [class.active]="currentTabId === 1">
          <button
            (click)="currentTabId = 1"
            [class.clickable]="true"
            [class.active]="currentTabId === 1"
            type="button">
            <span>{{ 'need_mapping.steps.title_1_short' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.storage.boxId > -1"
            [class.active]="currentTabId === 2">
          <button
            (click)="currentTabId = 2"
            [class.clickable]="current.storage.boxId > -1"
            [class.active]="currentTabId === 2"
            type="button">
            <span>{{ 'need_mapping.storage.inspiration.steps.title_1' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.storage.frontId > -1"
            [class.active]="currentTabId === 3">
          <button
            (click)="currentTabId = 3"
            [class.clickable]="current.storage.frontId > -1"
            [class.active]="currentTabId === 3"
            type="button">
            <span>{{ 'need_mapping.storage.inspiration.steps.title_2' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.storage.handlesId > -1"
            [class.active]="currentTabId === 4">
          <button
            (click)="currentTabId = 4"
            [class.clickable]="current.storage.handlesId > -1"
            [class.active]="currentTabId === 4"
            type="button">
            <span>{{ 'need_mapping.storage.inspiration.steps.title_3' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="current.storage.legsId > -1"
            [class.active]="currentTabId === 5">
          <button
            (click)="currentTabId = 5"
            [class.clickable]="current.storage.legsId > -1"
            [class.active]="currentTabId === 5"
            type="button">
            <span>{{ 'need_mapping.storage.inspiration.steps.title_4' | translate }}</span>
          </button>
        </li>
        <li [class.clickable]="true"
            [class.active]="currentTabId === 6">
          <button
            (click)="currentTabId = 6"
            [class.clickable]="true"
            [class.active]="currentTabId === 6"
            type="button">
            <span>{{ 'need_mapping.steps.title_6' | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="inspiration-choice-container">
      <ng-container [ngSwitch]="currentTabId">
        <ng-casto-storage-room *ngSwitchCase="1" (onComplete)="nextTab()"
                               (onSkipStep)="skipStep()"></ng-casto-storage-room>
        <ng-casto-storage-box *ngSwitchCase="2" (onComplete)="nextTab()"></ng-casto-storage-box>
        <ng-casto-storage-front *ngSwitchCase="3" (onComplete)="nextTab()"></ng-casto-storage-front>
        <ng-casto-storage-handles *ngSwitchCase="4" (onComplete)="nextTab()"></ng-casto-storage-handles>
        <ng-casto-storage-legs *ngSwitchCase="5" (onComplete)="nextTab()"></ng-casto-storage-legs>
        <ng-casto-storage-recap *ngSwitchCase="6" (onBackToStep)="currentTabId = $event"></ng-casto-storage-recap>
      </ng-container>
    </div>
  </div>
</div>
